import React from 'react';
import PropTypes from 'prop-types';

function CardNew({ children, className }) {
  return <div className={`bg-white border bs-black p-3 ${className}`}>{children}</div>;
}

export default CardNew;

CardNew.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
};
